export const findProgramLinks = (
  programQuickLinks,
  selectedProgram,
  programAccessMap,
) => {
  const match = programQuickLinks.find(({ permissionsPrograms }) => {
    if (!permissionsPrograms) {
      return false
    }
    if (selectedProgram.name === 'K8') {
      return (
        permissionsPrograms?.[
          programAccessMap?.[selectedProgram.name]?.k5program
        ] &&
        permissionsPrograms?.[
          programAccessMap?.[selectedProgram.name]?.msprogram
        ]
      )
    }
    return permissionsPrograms?.[
      programAccessMap?.[selectedProgram.name]?.program
    ]
  })
  // TODO: As apart of https://secondstep.atlassian.net/browse/LEARN-24976 bring this back and remove the code on line 26-28
  // return match?.supportLinks || []
  const supportLinks = match?.supportLinks || []
  return supportLinks.filter(
    link => !link.internalTitle?.toLowerCase().includes('unit settings'),
  )
}
